import { makeStyles, Theme, Typography } from '@material-ui/core';
import { Skeleton } from '@mui/material';
import { useRecoilValue } from 'recoil';

import { useQueryEntitiesPage } from 'src/hooks/useQueryEntitiesPage';
import { isAuthorizedQuery } from 'src/selectors/isAuthorizedQuery';

interface PropTypes {
    search: App.Entities.Search;
}

const useStyles = makeStyles((theme: Theme) => ({
    text: {
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'pre',
    },
    skeleton: {
        width: theme.spacing(10),
    },
}));

export const TotalDesigns = (props: PropTypes): JSX.Element | null => {
    const { search } = props;
    const classes = useStyles();
    const accessToken = useRecoilValue(isAuthorizedQuery);
    const { data, isLoading } = useQueryEntitiesPage(
        accessToken,
        search,
        { suspense: false, useErrorBoundary: false },
    );

    if (!isLoading && !data) {
        return null;
    }

    return (
        <Typography className={classes.text}>
            {'Total Designs: '}
            {isLoading ? <Skeleton className={classes.skeleton} /> : data?.total}
        </Typography>
    );
};
